/**
 * https://github.com/torana-us/ortega/wiki/Zindex%E8%A1%A8
 */
export const legalZIndex = 9999; // 法的に必須
export const userMustZIndex = 999; // ユーザー操作的に必須
export const headerZIndex = 10; // ヘッダー
export const developZIndex = 1; // 開発用
